import { useAllColors } from "http-hooks/color/useColor";
import DeleteColor from "components/color/DeleteColor";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  clrname: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "clrname", header: "Name" },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function ColorMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("color", id);

  const handleColorSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, clrname: searchTerm, page: 1 }));
  };

  const handleStatusChange = (statusOption) => {
    setSelectedStatus(statusOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: statusOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allcolors, page: currentPage, totalPages } = [],
  } = useAllColors(filter);

  return (
    <MasterPage
      title="Colour Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add color</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleColorSearch}
              label="Color Name"
              placeholder="Search Color Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              options={statusOptions}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allcolors}
      isLoading={isLoading}
      rowKey="clrId"
      deleteComponent={DeleteColor}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.clrId)}
            title="Edit Color"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.clrId)}
            title="Delete Color"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
